import React, { useState, useContext } from "react";
import {
  Box,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  Paper,
} from "@mui/material";
import { LangContext } from "../../LanguageProvider";

const emcourseData = [
  {
    id: 1,
    title_ru: "Учебно-методический план 2025-2026 учебного года",
    title_kz: "2025-2026 оқу жылына арналған оқу-әдістемелік жұмыс жоспары",
    pdf_path: "./pdf/uchebnometodplan.pdf",
  },
  {
    id: 2,
    title_ru: "Учебно-методический план совета 2025-2026 учебного года",
    title_kz:
      "2025-2026 оқу жылына арналған оқу-әдістемелік кеңес жұмысының жоспары",
    pdf_path: "./pdf/uchebnometodplansovet.pdf",
  },
];

export default function Emcourse() {
  const { lang } = useContext(LangContext);
  const [selectedPdf, setSelectedPdf] = useState(emcourseData[0]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" }, // Stack on mobile, row on desktop
        gap: 2,
        padding: 2,
        marginTop: "100px",
        marginBottom: "100px",
        height: "800px",
      }}>
      {/* Sidebar - PDF List */}
      <Paper
        elevation={3}
        sx={{
          width: { xs: "100%", md: "300px" },
          flexShrink: 0,
          overflowY: "auto",
        }}>
        <List component="nav">
          {emcourseData.map(item => (
            <ListItemButton
              key={item.id}
              selected={selectedPdf.id === item.id}
              onClick={() => setSelectedPdf(item)}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "primary.light",
                  color: "primary.contrastText",
                  "&:hover": {
                    backgroundColor: "primary.main",
                  },
                },
              }}>
              <ListItemText
                primary={lang === "ru" ? item.title_ru : item.title_kz}
              />
            </ListItemButton>
          ))}
        </List>
      </Paper>

      {/* Main Content - PDF Viewer */}
      <Box
        sx={{
          flexGrow: 1,
          height: "100%",
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          overflow: "hidden",
        }}>
        <iframe
          src={selectedPdf.pdf_path}
          title="PDF Viewer"
          width="100%"
          height="100%"
          style={{ border: "none" }}
        />
      </Box>
    </Box>
  );
}
